import "../Stylesheets/loaderComponent.css";
const LoadingComponent = () => {
  return <div className="loader"></div>;
};
export default LoadingComponent;
